import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const UploadImageIcon = (props: MuiIconExternalProps) => {
    return (
        <MuiIcon {...props}
        >{'\ue410'}</MuiIcon>
    );
}